import {createAction, props} from '@ngrx/store';
import {PaymentType} from '../../requests/constants/request-details.constants';
import {CodeNameModel} from '../../shared/models/code-name.model';
import {Warehouse} from '../../requests/models/warehouse.model';
import {PopItemTypeModel} from '../../requests/models/pop-design-request.model';

/**
 * Payment types
 */
export const loadPaymentTypes = createAction(
  '[RequestDetails RefData] Load Payment Types'
);
export const lazyLoadPaymentTypes = createAction(
  '[RequestDetails RefData] Lazy Load Payment Types'
);
export const loadPaymentTypesSuccess = createAction(
  '[RequestDetails RefData] Load Payment Types Success',
  props<{ paymentTypes: PaymentType[] }>()
);
export const loadPaymentTypesFailure = createAction(
  '[RequestDetails RefData] Load Payment Types Failure',
);

/**
 * Financial Service Payment types
 */
export const loadFSPaymentTypes = createAction(
  '[RequestDetails RefData] Load Financial Service Payment Types'
);
export const lazyLoadFSPaymentTypes = createAction(
  '[RequestDetails RefData] Lazy Load Financial Service Payment Types'
);
export const loadFSPaymentTypesSuccess = createAction(
  '[RequestDetails RefData] Load Financial Service Payment Types Success',
  props<{ fsPaymentTypes: PaymentType[] }>()
);
export const loadFSPaymentTypesFailure = createAction(
  '[RequestDetails RefData] Load Financial Service Payment Types Failure',
);

/**
 * Dielines
 */
export const loadDielines = createAction(
  '[RequestDetails RefData] Load Dielines'
);
export const lazyLoadDielines = createAction(
  '[RequestDetails RefData] Lazy Load Dielines'
);
export const loadDielinesSuccess = createAction(
  '[RequestDetails RefData] Load Dielines Success',
  props<{ dielines: CodeNameModel[] }>()
);
export const loadDielinesFailure = createAction(
  '[RequestDetails RefData] Load Dielines Failure',
);

/**
 * Data pin file types
 */
export const loadDataPinFileTypes = createAction(
  '[RequestDetails RefData] Load DataPinFileTypes'
);
export const lazyLoadDataPinFileTypes = createAction(
  '[RequestDetails RefData] Lazy Load DataPinFileTypes'
);
export const loadDataPinFileTypesSuccess = createAction(
  '[RequestDetails RefData] Load DataPinFileTypes Success',
  props<{ dataPinFileTypes: CodeNameModel[] }>()
);
export const loadDataPinFileTypesFailure = createAction(
  '[RequestDetails RefData] Load DataPinFileTypes Failure',
);

/**
 * Substrates
 */
export const loadSubstrates = createAction(
  '[RequestDetails RefData] Load Substrates'
);
export const lazyLoadSubstrates = createAction(
  '[RequestDetails RefData] Lazy Load Substrates'
);
export const loadSubstratesSuccess = createAction(
  '[RequestDetails RefData] Load Substrates Success',
  props<{ substrates: CodeNameModel[] }>()
);
export const loadSubstratesFailure = createAction(
  '[RequestDetails RefData] Load Substrates Failure',
);

/**
 * RedemptionTypes
 */
export const loadRedemptionTypes = createAction(
  '[RequestDetails RefData] Load RedemptionTypes'
);
export const lazyLoadRedemptionTypes = createAction(
  '[RequestDetails RefData] Lazy Load RedemptionTypes'
);
export const loadRedemptionTypesSuccess = createAction(
  '[RequestDetails RefData] Load RedemptionTypes Success',
  props<{ redemptionTypes: CodeNameModel[] }>()
);
export const loadRedemptionTypesFailure = createAction(
  '[RequestDetails RefData] Load RedemptionTypes Failure',
);

/**
 * RequestItemTypes
 */
export const loadRequestItemTypes = createAction(
  '[RequestDetails RefData] Load RequestItemTypes'
);
export const lazyLoadRequestItemTypes = createAction(
  '[RequestDetails RefData] Lazy Load RequestItemTypes'
);
export const loadRequestItemTypesSuccess = createAction(
  '[RequestDetails RefData] Load RequestItemTypes Success',
  props<{ requestItemTypes: CodeNameModel[] }>()
);
export const loadRequestItemTypesFailure = createAction(
  '[RequestDetails RefData] Load RequestItemTypes Failure',
);

/**
 * Regions
 */
export const loadRegions = createAction(
  '[RequestDetails RefData] Load Regions'
);
export const lazyLoadRegions = createAction(
  '[RequestDetails RefData] Lazy Load Regions'
);
export const loadRegionsSuccess = createAction(
  '[RequestDetails RefData] Load Regions Success',
  props<{ regions: CodeNameModel[] }>()
);
export const loadRegionsFailure = createAction(
  '[RequestDetails RefData] Load Regions Failure',
);

/**
 * Warehouses
 */
export const loadWarehouses = createAction(
  '[RequestDetails RefData] Load Warehouses'
);
export const lazyLoadWarehouses = createAction(
  '[RequestDetails RefData] Lazy Load Warehouses'
);
export const loadWarehousesSuccess = createAction(
  '[RequestDetails RefData] Load Warehouses Success',
  props<{ warehouses: Warehouse[] }>()
);
export const loadWarehousesFailure = createAction(
  '[RequestDetails RefData] Load Warehouses Failure',
);
/**
 * Companies
 */
export const loadCompanies = createAction(
  '[RequestDetails RefData] Load Companies'
);
export const lazyLoadCompanies = createAction(
  '[RequestDetails RefData] Lazy Load Companies'
);
export const loadCompaniesSuccess = createAction(
  '[RequestDetails RefData] Load Companies Success',
  props<{ companies: CodeNameModel[] }>()
);
export const loadCompaniesFailure = createAction(
  '[RequestDetails RefData] Load Companies Failure',
);
/**
 * PartnerGroups
 */
export const loadPartnerGroups = createAction(
  '[RequestDetails RefData] Load PartnerGroups'
);
export const lazyLoadPartnerGroups = createAction(
  '[RequestDetails RefData] Lazy Load PartnerGroups'
);
export const loadPartnerGroupsSuccess = createAction(
  '[RequestDetails RefData] Load PartnerGroups Success',
  props<{ partnerGroups: CodeNameModel[] }>()
);
export const loadPartnerGroupsFailure = createAction(
  '[RequestDetails RefData] Load PartnerGroups Failure',
);

/**
 * Design line of business
 */
export const loadDesignLineOfBusiness = createAction(
  '[RequestDetails RefData] Load DesignLineOfBusiness'
);
export const loadDesignLineOfBusinessSuccess = createAction(
  '[RequestDetails RefData] Load DesignLineOfBusiness Success',
  props<{ designLineOfBusiness: CodeNameModel[] }>()
);
export const loadDesignLineOfBusinessFailure = createAction(
  '[RequestDetails RefData] Load DesignLineOfBusiness Failure',
);
export const lazyLoadDesignLineOfBusiness = createAction(
  '[RequestDetails RefData] Lazy Load DesignLineOfBusiness'
);

/**
 * ArtLocationsTypes
 */
export const loadArtLocationsTypes = createAction(
  '[RequestDetails RefData] Load ArtLocationsTypes'
);
export const lazyLoadArtLocationsTypes = createAction(
  '[RequestDetails RefData] Lazy Load ArtLocationsTypes'
);
export const loadArtLocationsTypesSuccess = createAction(
  '[RequestDetails RefData] Load ArtLocationsTypes Success',
  props<{ artLocationTypes: CodeNameModel[] }>()
);
export const loadArtLocationsTypesFailure = createAction(
  '[RequestDetails RefData] Load ArtLocationsTypes Failure',
);

/**
 * DesignSourceTypes
 */
export const loadDesignSourceTypes = createAction(
  '[RequestDetails RefData] Load DesignSourceTypes'
);
export const lazyLoadDesignSourceTypes = createAction(
  '[RequestDetails RefData] Lazy Load DesignSourceTypes'
);
export const loadDesignSourceTypesSuccess = createAction(
  '[RequestDetails RefData] Load DesignSourceTypes Success',
  props<{ designSourceTypes: CodeNameModel[] }>()
);
export const loadDesignSourceTypesFailure = createAction(
  '[RequestDetails RefData] Load DesignSourceTypes Failure',
);

/**
 * ChannelTypes
 */
export const loadChannelTypes = createAction(
  '[RequestDetails RefData] Load ChannelTypes'
);
export const lazyLoadChannelTypes = createAction(
  '[RequestDetails RefData] Lazy Load ChannelTypes'
);
export const loadChannelTypesSuccess = createAction(
  '[RequestDetails RefData] Load ChannelTypes Success',
  props<{ channelTypes: CodeNameModel[] }>()
);
export const loadChannelTypesFailure = createAction(
  '[RequestDetails RefData] Load ChannelTypes Failure',
);
/**
 * Pop ChannelTypes
 */
export const loadPopChannelTypes = createAction(
  '[RequestDetails RefData] Load PopChannelTypes'
);
export const lazyLoadPopChannelTypes = createAction(
  '[RequestDetails RefData] Lazy Load PopChannelTypes'
);
export const loadPopChannelTypesSuccess = createAction(
  '[RequestDetails RefData] Load PopChannelTypes Success',
  props<{ popChannelTypes: CodeNameModel[] }>()
);
export const loadPopChannelTypesFailure = createAction(
  '[RequestDetails RefData] Load PopChannelTypes Failure',
);

/**
 * InventoryTypes
 */
export const loadInventoryTypes = createAction(
  '[RequestDetails RefData] Load InventoryTypes'
);
export const lazyLoadInventoryTypes = createAction(
  '[RequestDetails RefData] Lazy Load InventoryTypes'
);
export const loadInventoryTypesSuccess = createAction(
  '[RequestDetails RefData] Load InventoryTypes Success',
  props<{ inventoryTypes: CodeNameModel[] }>()
);
export const loadInventoryTypesFailure = createAction(
  '[RequestDetails RefData] Load InventoryTypes Failure',
);

/**
 * RequestTypeInventoryTypes
 */
export const loadRequestTypeInventoryTypes = createAction(
  '[RequestDetails RefData] Load RequestTypeInventoryTypes',
  props<{ requestType: string }>()
);
export const lazyLoadRequestTypeInventoryTypes = createAction(
  '[RequestDetails RefData] Lazy Load RequestTypeInventoryTypes',
  props<{ requestType: string }>()
);
export const loadRequestTypeInventoryTypesSuccess = createAction(
  '[RequestDetails RefData] Load RequestTypeInventoryTypes Success',
  props<{ requestTypeInventoryTypes: CodeNameModel[] }>()
);
export const loadRequestTypeInventoryTypesFailure = createAction(
  '[RequestDetails RefData] Load RequestTypeInventoryTypes Failure',
);

/**
 * ComponentTypes
 */
export const loadComponentTypes = createAction(
  '[RequestDetails RefData] Load ComponentTypes'
);
export const lazyLoadComponentTypes = createAction(
  '[RequestDetails RefData] Lazy Load ComponentTypes'
);
export const loadComponentTypesSuccess = createAction(
  '[RequestDetails RefData] Load ComponentTypes Success',
  props<{ componentTypes: CodeNameModel[] }>()
);
export const loadComponentTypesFailure = createAction(
  '[RequestDetails RefData] Load ComponentTypes Failure',
);

/**
 * PopItemTypes
 */
export const loadPopItemTypes = createAction(
  '[RequestDetails RefData] Load PopItemTypes'
);
export const lazyLoadPopItemTypes = createAction(
  '[RequestDetails RefData] Lazy Load PopItemTypes'
);
export const loadPopItemTypesSuccess = createAction(
  '[RequestDetails RefData] Load PopItemTypes Success',
  props<{ popItemTypes: PopItemTypeModel[] }>()
);
export const loadPopItemTypesFailure = createAction(
  '[RequestDetails RefData] Load PopItemTypes Failure',
);

/**
 * ColorTypes
 */
export const loadColorTypes = createAction(
  '[RequestDetails RefData] Load ColorTypes'
);
export const lazyLoadColorTypes = createAction(
  '[RequestDetails RefData] Lazy Load ColorTypes'
);
export const loadColorTypesSuccess = createAction(
  '[RequestDetails RefData] Load ColorTypes Success',
  props<{ colorTypes: CodeNameModel[] }>()
);
export const loadColorTypesFailure = createAction(
  '[RequestDetails RefData] Load ColorTypes Failure',
);

/**
 * DimensionTypes
 */
export const loadDimensionTypes = createAction(
  '[RequestDetails RefData] Load DimensionTypes'
);
export const lazyLoadDimensionTypes = createAction(
  '[RequestDetails RefData] Lazy Load DimensionTypes'
);
export const loadDimensionTypesSuccess = createAction(
  '[RequestDetails RefData] Load DimensionTypes Success',
  props<{ dimensionTypes: CodeNameModel[] }>()
);
export const loadDimensionTypesFailure = createAction(
  '[RequestDetails RefData] Load DimensionTypes Failure',
);

/**
 * FinancialTypes
 */
export const loadFinancialTypes = createAction(
  '[RequestDetails RefData] Load FinancialTypes'
);
export const lazyLoadFinancialTypes = createAction(
  '[RequestDetails RefData] Lazy Load FinancialTypes'
);
export const loadFinancialTypesSuccess = createAction(
  '[RequestDetails RefData] Load FinancialTypes Success',
  props<{ financialTypes: CodeNameModel[] }>()
);
export const loadFinancialTypesFailure = createAction(
  '[RequestDetails RefData] Load FinancialTypes Failure',
);
/**
 * Pop EventTypes
 */
export const loadPopProdEventTypes = createAction(
  '[RequestDetails RefData] Load EventTypes'
);
export const lazyLoadPopProdEventTypes = createAction(
  '[RequestDetails RefData] Lazy Load EventTypes'
);
export const loadPopProdEventTypesSuccess = createAction(
  '[RequestDetails RefData] Load EventTypes Success',
  props<{ popProdEventTypes: CodeNameModel[] }>()
);
export const loadPopProdEventTypesFailure = createAction(
  '[RequestDetails RefData] Load EventTypes Failure',
);
/**
 * Pop FundingTypes
 */
export const loadPopProdFundingTypes = createAction(
  '[RequestDetails RefData] Load FundingTypes'
);
export const lazyLoadPopProdFundingTypes = createAction(
  '[RequestDetails RefData] Lazy Load FundingTypes'
);
export const loadPopProdFundingTypesSuccess = createAction(
  '[RequestDetails RefData] Load FundingTypes Success',
  props<{ popProdFundingTypes: CodeNameModel[] }>()
);
export const loadPopProdFundingTypesFailure = createAction(
  '[RequestDetails RefData] Load FundingTypes Failure',
);
/**
 * Pop UsageDurationTypes
 */
export const loadPopProdUsageDurationTypes = createAction(
  '[RequestDetails RefData] Load UsageDurationTypes'
);
export const lazyLoadPopProdUsageDurationTypes = createAction(
  '[RequestDetails RefData] Lazy Load UsageDurationTypes'
);
export const loadPopProdUsageDurationTypesSuccess = createAction(
  '[RequestDetails RefData] Load UsageDurationTypes Success',
  props<{ popUsageDurationTypes: CodeNameModel[] }>()
);
export const loadPopProdUsageDurationTypesFailure = createAction(
  '[RequestDetails RefData] Load UsageDurationTypes Failure',
);
/**
 * Pop Prod ItemTypes
 */
export const loadPopProdItemTypes = createAction(
  '[RequestDetails RefData] Load Pop Prod ItemTypes'
);
export const lazyLoadPopProdItemTypes = createAction(
  '[RequestDetails RefData] Lazy Load Pop Prod ItemTypes'
);
export const loadPopProdItemTypesSuccess = createAction(
  '[RequestDetails RefData] Load Pop Prod ItemTypes Success',
  props<{ popProdItemTypes: PopItemTypeModel[] }>()
);
export const loadPopProdItemTypesFailure = createAction(
  '[RequestDetails RefData] Load Pop Prod ItemTypes Failure',
);
export const lazyLoadPopProdCuttingTypes = createAction(
  '[RequestDetails RefData] Lazy Load Pop Prod CuttingTypes',
);
/**
 * Pop Prod CuttingTypes
 */
export const loadPopProdCuttingTypes = createAction(
  '[RequestDetails RefData] Load Pop Prod CuttingTypes',
);
export const loadPopProdCuttingTypesSuccess = createAction(
  '[RequestDetails RefData] Load Pop Prod CuttingTypes Success',
  props<{ popProdCuttingTypes: CodeNameModel[] }>(),
);
export const loadPopProdCuttingTypesFailure = createAction(
  '[RequestDetails RefData] Load Pop Prod CuttingTypes Failure',
);
export const lazyLoadPopProdMaterialTypes = createAction(
  '[RequestDetails RefData] Lazy Load Pop Prod MaterialTypes',
);
/**
 * Pop Prod MaterialTypes
 */
export const loadPopProdMaterialTypes = createAction(
  '[RequestDetails RefData] Load Pop Prod MaterialTypes',
);
export const loadPopProdMaterialTypesSuccess = createAction(
  '[RequestDetails RefData] Load Pop Prod MaterialTypes Success',
  props<{ popProdMaterialTypes: CodeNameModel[] }>(),
);
export const loadPopProdMaterialTypesFailure = createAction(
  '[RequestDetails RefData] Load Pop Prod MaterialTypes Failure',
);
export const lazyLoadPopProdTapeTypes = createAction(
  '[RequestDetails RefData] Lazy Load Pop Prod TapeTypes',
);
/**
 * Pop Prod TapeTypes
 */
export const loadPopProdTapeTypes = createAction(
  '[RequestDetails RefData] Load Pop Prod TapeTypes',
);
export const loadPopProdTapeTypesSuccess = createAction(
  '[RequestDetails RefData] Load Pop Prod TapeTypes Success',
  props<{ popProdTapeTypes: CodeNameModel[] }>(),
);
export const loadPopProdTapeTypesFailure = createAction(
  '[RequestDetails RefData] Load Pop Prod TapeTypes Failure',
);
/**
 * Pop Prod InventoryTypes
 */
export const loadPopProdInventoryTypes = createAction(
  '[RequestDetails RefData] Load Pop Prod InventoryTypes'
);
export const lazyLoadPopProdInventoryTypes = createAction(
  '[RequestDetails RefData] Lazy Load Pop Prod InventoryTypes'
);
export const loadPopProdInventoryTypesSuccess = createAction(
  '[RequestDetails RefData] Load Pop Prod InventoryTypes Success',
  props<{ popProdInventoryTypes: CodeNameModel[] }>()
);
export const loadPopProdInventoryTypesFailure = createAction(
  '[RequestDetails RefData] Load Pop Prod InventoryTypes Failure',
);

/**
 * Printers
 */
export const loadPrinters = createAction(
  '[RequestDetails RefData] Load Printers'
);
export const lazyLoadPrinters = createAction(
  '[RequestDetails RefData] Lazy Load Printers'
);
export const loadPrintersSuccess = createAction(
  '[RequestDetails RefData] Load Printers Success',
  props<{ printers: any[] }>()
);
export const loadPrintersFailure = createAction(
  '[RequestDetails RefData] Load Printers Failure',
);

/**
 * BifComponentTypes
 */
export const loadBifComponentTypes = createAction(
  '[RequestDetails RefData] Load BifComponentTypes'
);
export const lazyLoadBifComponentTypes = createAction(
  '[RequestDetails RefData] Lazy Load BifComponentTypes'
);
export const loadBifComponentTypesSuccess = createAction(
  '[RequestDetails RefData] Load BifComponentTypes Success',
  props<{ bifComponentTypes: CodeNameModel[] }>()
);
export const loadBifComponentTypesFailure = createAction(
  '[RequestDetails RefData] Load BifComponentTypes Failure',
);

/**
 * BifFulfillmentTypes
 */
export const loadBifFulfillmentTypes = createAction(
  '[RequestDetails RefData] Load BifFulfillmentTypes'
);
export const lazyLoadBifFulfillmentTypes = createAction(
  '[RequestDetails RefData] Lazy Load BifFulfillmentTypes'
);
export const loadBifFulfillmentTypesSuccess = createAction(
  '[RequestDetails RefData] Load BifFulfillmentTypes Success',
  props<{ bifFulfillmentTypes: CodeNameModel[] }>()
);
export const loadBifFulfillmentTypesFailure = createAction(
  '[RequestDetails RefData] Load BifFulfillmentTypes Failure',
);

/**
 * ThirdPartyDataPinFileTypes
 */
export const loadThirdPartyDataPinFileTypes = createAction(
  '[RequestDetails RefData] Load ThirdPartyDataPinFileTypes'
);
export const lazyLoadThirdPartyDataPinFileTypes = createAction(
  '[RequestDetails RefData] Lazy Load ThirdPartyDataPinFileTypes'
);
export const loadThirdPartyDataPinFileTypesSuccess = createAction(
  '[RequestDetails RefData] Load ThirdPartyDataPinFileTypes Success',
  props<{ thirdPartyDataPinFileTypes: CodeNameModel[] }>()
);
export const loadThirdPartyDataPinFileTypesFailure = createAction(
  '[RequestDetails RefData] Load ThirdPartyDataPinFileTypes Failure',
);

/**
 * ThirdPartyOrderTypes
 */
export const loadThirdPartyOrderTypes = createAction(
  '[RequestDetails RefData] Load ThirdPartyOrderTypes'
);
export const lazyLoadThirdPartyOrderTypes = createAction(
  '[RequestDetails RefData] Lazy Load ThirdPartyOrderTypes'
);
export const loadThirdPartyOrderTypesSuccess = createAction(
  '[RequestDetails RefData] Load ThirdPartyOrderTypes Success',
  props<{ thirdPartyOrderTypes: CodeNameModel[] }>()
);
export const loadThirdPartyOrderTypesFailure = createAction(
  '[RequestDetails RefData] Load ThirdPartyOrderTypes Failure',
);

/**
 * ThirdPartyPrintOwnerTypes
 */
export const loadThirdPartyPrintOwnerTypes = createAction(
  '[RequestDetails RefData] Load ThirdPartyPrintOwnerTypes'
);
export const lazyLoadThirdPartyPrintOwnerTypes = createAction(
  '[RequestDetails RefData] Lazy Load ThirdPartyPrintOwnerTypes'
);
export const loadThirdPartyPrintOwnerTypesSuccess = createAction(
  '[RequestDetails RefData] Load ThirdPartyPrintOwnerTypes Success',
  props<{ thirdPartyPrintOwnerTypes: Array<CodeNameModel & {internal: boolean}> }>()
);
export const loadThirdPartyPrintOwnerTypesFailure = createAction(
  '[RequestDetails RefData] Load ThirdPartyPrintOwnerTypes Failure',
);

export const loadThirdPartyCompanies = createAction(
  '[RequestDetails RefData] Load ThirdPartyCompanies'
);
export const lazyLoadThirdPartyCompanies = createAction(
  '[RequestDetails RefData] Lazy Load ThirdPartyCompanies'
);
export const loadThirdPartyCompaniesSuccess = createAction(
  '[RequestDetails RefData] Load ThirdPartyCompanies Success',
  props<{ thirdPartyCompanies: CodeNameModel[] }>()
);
export const loadThirdPartyCompaniesFailure = createAction(
  '[RequestDetails RefData] Load ThirdPartyCompanies Failure',
);

/**
 * IhComponents
 */
export const loadIhComponents = createAction(
  '[RequestDetails RefData] Load IhComponents',
);
export const lazyLoadIhComponents = createAction(
  '[RequestDetails RefData] Lazy Load IhComponents',
);
export const loadIhComponentsSuccess = createAction(
  '[RequestDetails RefData] Load IhComponents Success',
  props<{ ihComponents: CodeNameModel[] }>(),
);
export const loadIhComponentsFailure = createAction(
  '[RequestDetails RefData] Load IhComponents Failure',
);

/**
 * IhPriorities
 */
export const loadIhPriorities = createAction(
  '[RequestDetails RefData] Load IhPriorities',
);
export const lazyLoadIhPriorities = createAction(
  '[RequestDetails RefData] Lazy Load IhPriorities',
);
export const loadIhPrioritiesSuccess = createAction(
  '[RequestDetails RefData] Load IhPriorities Success',
  props<{ ihPriorities: Array<CodeNameModel & {value: number}> }>(),
);
export const loadIhPrioritiesFailure = createAction(
  '[RequestDetails RefData] Load IhPriorities Failure',
);

/**
 * ReturnFileTypes
 */
export const loadReturnFileTypes = createAction(
  '[RequestDetails RefData] Load ReturnFileTypes',
);
export const lazyLoadReturnFileTypes = createAction(
  '[RequestDetails RefData] Lazy Load ReturnFileTypes',
);
export const loadReturnFileTypesSuccess = createAction(
  '[RequestDetails RefData] Load ReturnFileTypes Success',
  props<{ returnFileTypes: CodeNameModel[] }>(),
);
export const loadReturnFileTypesFailure = createAction(
  '[RequestDetails RefData] Load ReturnFileTypes Failure',
);

/**
 * ImageFormatType
 */
export const loadImageFormatTypes = createAction(
  '[RequestDetails RefData] Load ImageFormatTypes',
);
export const lazyLoadImageFormatTypes = createAction(
  '[RequestDetails RefData] Lazy Load ImageFormatTypes',
);
export const loadImageFormatTypesSuccess = createAction(
  '[RequestDetails RefData] Load ImageFormatTypes Success',
  props<{ imageFormatTypes: CodeNameModel[] }>(),
);
export const loadImageFormatTypesFailure = createAction(
  '[RequestDetails RefData] Load ImageFormatTypes Failure',
);
